import FollowupView from "./FollowupView";

export default FollowupView;